import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  ThemeProvider,
  CssBaseline,
  Backdrop,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';
import { GET_TESTSTEPS_REPORT_BY_REPORTID_URL, } from "envConfig";
import { Logger } from "utils/Logger";
import { useParams } from "react-router-dom";
import { TestStep } from "../../Interfaces/AutomateTest";
import { useTheme } from "@emotion/react";

export const AllTestStepsReport: React.FC = () => {
  const { reportId, testCaseId} = useParams<{ reportId: string, testCaseId: string }>();
  const [testStepsReports, setTestStepsReports] = useState<TestStep[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const theme = useTheme();

    const fetchTestStepsReports = async () => {
      try {
        setLoading(true);
        const response = await fetch(GET_TESTSTEPS_REPORT_BY_REPORTID_URL + `/${reportId}/${testCaseId}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
            Logger.error("st-ck-client/src/modules/AutomateTest/AllTestStepsReport/AllTestStepsReport.ts : fetchTestStepsReports(): issue while getting Steps Report, response is " , response.statusText);
            setLoading(false);
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        if (Array.isArray(data.data)) {
          setTestStepsReports(data.data);
          setLoading(false);
          Logger.info("st-ck-client/src/modules/AutomateTest/AllTestStepsReport/AllTestStepsReport.ts : fetchTestStepsReports(): Step Reports " , JSON.stringify(data.data, null, 2));
        } else {
            Logger.error("st-ck-client/src/modules/AutomateTest/AllTestStepsReport/AllTestStepsReport.ts : fetchTestStepsReports(): ", "Unexpected API response format: " + JSON.stringify(data.data, null, 2));
            setTestStepsReports([]);
            setLoading(false);
        }
      } catch (error) {
        Logger.error("st-ck-client/src/modules/AutomateTest/AllTestStepsReport/AllTestStepsReport.ts : fetchTestStepsReports(): ", "Failed to fetch Steps Reports: "+ error);
        setTestStepsReports([]);
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchTestStepsReports();
    }, []);

    const handleRedirect = (assetPath:string) => {
      window.location.href = assetPath;
    };

  return (loading ?
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Backdrop
        sx={(theme) => ({ color: theme.palette.secondary.main, zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </ThemeProvider>
    :
    <Box pl={{ xs: 1.25, sm: 2.5 }} pt={1} width="100%">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="h4" gutterBottom>All TestSteps Reports</Typography>
      </Box>
      <TableContainer component={Paper} sx={{ maxHeight: "550px", overflow: "auto" }}>
          <Table sx={{ tableLayout: "auto", "& td, & th": { maxWidth: "130px", width:"150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>TESTSTEP</TableCell>
              <TableCell>DESCRIPTION</TableCell>
              <TableCell>ACTION</TableCell>
              <TableCell>STATUS</TableCell>
              <TableCell>Error</TableCell>
              <TableCell>SCREENSHOT</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {testStepsReports.map((testStepsReport, index) => (
              <TableRow key={testStepsReport._id}>
                <TableCell>{index}</TableCell>
                <TableCell>{testStepsReport.name}</TableCell>
                <TableCell>{testStepsReport.description}</TableCell>
                <TableCell>{testStepsReport.action}</TableCell>
                <TableCell>{testStepsReport.status}</TableCell>
                <TableCell>{testStepsReport.error}</TableCell>
                <TableCell>
                  <>
                  <IconButton onClick={() => handleRedirect(testStepsReport?.screenshotsLocation || "")} disabled={!testStepsReport?.screenshotsLocation}
      >             <ImageIcon/>
                  </IconButton>
                  </>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
